import { Component } from "react";
import windowSize from "react-window-size";

class ScreenSize extends Component {
  constructor(state, props) {
    super(state, props);
    this.state = {
      width: 0,
      dataTarget: ""
    };
  }

  //pass the updated dataTarget value back to App
  onChangeDataTarget = value => {
    this.props.onChangeDataTarget(value);
  };

  componentWillReceiveProps(nextProps) {
    //if the screen width has changed, then update the dataTarget value
    if (this.state.width !== nextProps.windowWidth) {
      this.setState({ width: nextProps.windowWidth });

      //console.log(nextProps.windowWidth);
      var dataTarget = "";
      if (nextProps.windowWidth <= 599) {
        dataTarget = "#myNavbar";
      }
      if (nextProps.windowWidth >= 600) {
        dataTarget = "noNavbar";
      }

      this.props.onChangeDataTarget(dataTarget);
    }
  }

  render() {
    return null;
  }
}

export default windowSize(ScreenSize);



// WEBPACK FOOTER //
// ./src/lib/ScreenSize.js